<a
  class="m-0 font-semibold text-brand-chathams-blue hover:text-blue-500 underline cursor-pointer block truncate"
  *ngIf="dropdownList && dropdownList.length > 0"
  [matMenuTriggerFor]="aboveMenu">
  {{value}}
</a>
<p
  class="m-0 font-semibold block truncate"
  *ngIf="!dropdownList"
  [matTooltip]="valueTooltip || ''"
  [matTooltipDisabled]="!valueTooltip"
  matTooltipShowDelay="200">
  {{value}}
</p>
<p class="mb-0 text-sm text-gray-800 leading-none cursor-pointer" matTooltipShowDelay="200" [matTooltip]="tooltip | translate">
  {{label | translate}}
</p>

<mat-menu #aboveMenu="matMenu" yPosition="below" xPosition="before">
  <div class="pt-0 p-2 text-center">{{'exposures.targetGroups' | translate }}</div>
  <mat-divider></mat-divider>

  <ul class="p-1">
    <li class="pb-0 p-1 text-center" *ngFor="let targetGroup of targetGroups">
      <span>{{ targetGroup | translate }}</span>
    </li>
  </ul>
</mat-menu>
